<div [id]="backgroundImageId" class="bg-image shadow" color="primary">
  <div class="mask d-flex align-items-center h-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-10 col-md-10 col-lg-5 col-xl-5 col-xxl-4">
          <form class="bg-white rounded shadow-5-strong p-4">
            <div class="d-flex justify-content-center" >
              <div class="col-md-8 col-sm-12 d-flex justify-content-center">
                <img [src]="logoUrl" alt="IEA logo" class="logo" />
              </div>
            </div>
            <div class="col-12 text-center">

              <h1 class="error mt-3 fw-bold">Oops!</h1>
              <p class="px-0 px-md-4 px-lg-4 px-xl-4 px-xxl-4">
                <span class="error">Your account is not verified. <br>
                Please check your email to complete account setup.</span>
                <br><br> <span> Didn’t receive a code? Check your junk mail or
                click below to verify your account.</span>
              </p>
            </div>
            
            <!-- Submit button -->
            <button type="button" (click)="navigateToSignupVerify()" class="btn btn-primary btn-block w-100 py-2 mt-3">
              Verify your Account
            </button>

            <div class="col-12 text-center mt-3">
              <img class="footer-logo" src="../../../assets/images/poweredby-OneEquineblack-logo.png" alt="IEA logo" />
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>
